<template>
    <section class="reply-box">
        <textarea placeholder="您的回复会被公开展示，请注意措辞" @keyup="changeFontNum" v-model.trim="reply"></textarea>
        <footer>
            <span>已经输入{{ fontNum }}个字，共可以输入500字</span>
            <input type="button" value="提交" :disabled="submitStatus" @click="submitReply" />
            <input type="button" value="取消" @click="hideReply" />
        </footer>
    </section>
</template>

<style lang="postcss">
    .reply-box {
        height: 120px;
        margin-top: 10px;
        overflow: hidden;
        background-color: #F7F9FA;
        & > textarea {
            width: 100%;
            height: 82px;
            border: 0;
            background-color: #F7F9FA;
        }
        & > footer {
            width: 100%;
            height: 28px;
            line-height: 28px;
            & > span {
                color: #CCCCCC;
                margin-left: 11px;
            }
            & > input[type="button"] {
                float: right;
                margin-right: 15px;
                border: 0;
                display: inline-block;
                &:nth-of-type(1) {
                    width: 68px;
                    height: 100%;
                    background-color: #36A7F4;
                    color: #FFF;
                    border-radius: 100px;
                    &[disabled] {
                        background-color: #DFE2E5;
                        cursor: no-drop;
                    }
                }
                &:nth-of-type(2) {
                    background-color: transparent;
                    color: #36A7F4;
                }
            }
        }
    }
</style>

<script>
    import Comment from 'api/comment'

    export default {
        data () {
            return {
                reply: this.replyContent, // 回复内容
                submitStatus: true // 提交按钮状态
            }
        },
        props: ['replyContent', 'did', 'commentId', 'poiId'],
        computed: {
            fontNum: function () {
                return this.reply.length
            }
        },
        methods: {
            // 点击取消按钮
            hideReply () {
                this.$emit('cancel')
            },

            // 限制输入框字数
            changeFontNum () {
                if (this.fontNum >= 500 || this.fontNum <= 0) {
                    this.submitStatus = true
                } else {
                    this.submitStatus = false
                }
            },

            // 提交
            submitReply () {
                if (!this.did) {
                    return
                }
                if (this.submitStatus || this.fontNum >= 500 || this.fontNum <= 0) {
                    this.$notify.error({
                        title: '错误',
                        message: '格式错误'
                    })
                    return
                }
                Comment.postCommentReply(this.did, this.reply, this.commentId, this.poiId)
                    .then((res) => {
                        if (res.status === 0) {
                            this.$message.success('提交成功')
                            this.$emit('cancel', { bizReply: res.data.bizReply, replyTime: res.data.replyTime })
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: err.message || '提交失败，请稍后再试'
                            })
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$notify.error({
                            title: '错误',
                            message: err.message || '出错了，请稍后再试'
                        })
                    })
            }
        },
        created () {
            this.changeFontNum()
        }
    }
</script>



// WEBPACK FOOTER //
// Reply.vue?713b838b